import store from '@/store'
import { find } from 'lodash'
// services
import db from '@/services/db'
import utils from '@/helpers/utils'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  async rowAdded(newRow) {
    const { currentDash, dataGrid_options } = store.state

    if (currentDash === 'core') return newRow

    const { pagesTable_createTableOnAdded: createTable } = dataGrid_options[
      'pages'
    ]

    const tabKey = await new Promise(function(resolve) {
      const data = {
        dash: currentDash,
        title: newRow.name || 'New Page',
        sync: true
      }

      db.tabs.create(data, function(key) {
        resolve(key)
      })
    })

    const newRowMutated = Object.assign({}, newRow, {
      name: newRow.name || 'New Page',
      tabKey,
    })

    if (!createTable) return newRowMutated

    let newTable

    if (newRow.name) {
      if (utils.sanitize(newRow.name) in dataGrid_options) {
        let counter = 1

        do {
          newTable = `${newRow.name} ${counter}`

          counter++
        } while (utils.sanitize(newTable) in dataGrid_options)
      } else {
        newTable = newRow.name
      }
    } else {
      let counter = 1

      do {
        newTable = `Grid ${counter}`

        counter++
      } while (utils.sanitize(newTable) in dataGrid_options)
    }

    const data = {
      title: newTable,
      source: utils.sanitize(newTable),
      storageType: 'dashboard',
      tab: tabKey,
      gsOptions: {
        w: 24,
        h: 18,
      },
    }

    store.commit(
      'dataGrid_setOptions',
      Object.assign({}, dataGrid_options, { [data.source]: {} })
    )

    db.dataGrid.widget.createNew(data).then(function() {
      eventBus.$emit('dataGridAdded', data.source)
    })

    return newRowMutated
  },
  removeRow(rowKey) {
    const { currentDash } = store.state

    if (currentDash === 'core') return

    const row = $dataGrid('pages')[rowKey]

    if (!row.tabKey) return

    db.tabs.delete(row.tabKey)
  },
  cellChanged(rowKey, cellKey) {
    const { currentDash } = store.state

    if (currentDash === 'core') return
    if (cellKey !== 'name') return

    const row = $dataGrid('pages')[rowKey]

    db.tabs.renameTab(row.name, row.tabKey)
  },
  tabAdded(title, tabKey) {
    const { currentDash } = store.state

    if (currentDash === 'core') return

    db.dataGrid.data.addRow('pages', { name: title, tabKey }, true)
  },
  tabRemoved(tabKey) {
    const { currentDash } = store.state

    if (currentDash === 'core') return

    const { rowKey } = find($dataGrid('pages'), { tabKey })

    db.dataGrid.data.removeRow('pages', rowKey, true)
  },
  tabRenamed(title, tabKey) {
    const { currentDash, dataGrid_options } = store.state

    if (currentDash === 'core') return

    const { rowKey } = find($dataGrid('pages'), { tabKey })

    const data = {
      options: dataGrid_options['pages'],
      rowKey,
      cellKey: 'name',
      value: title,
    }

    db.dataGrid.data.saveCellVal(data, true)
  }
}
